<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    item-text="name"
    item-value="id"
    label="Права"
    no-data-text="Право не найдено"
    :request="request"
    v-on="$listeners"
  >
    <template #item="{ item }">
      <v-list-item-content>
        <v-list-item-title
          class="body-2 font-weight-regular"
          style="white-space: initial;"
          v-text="item.name"
        />
        <v-list-item-subtitle
          class="font-weight-regular grey--text text--lighten-1"
          style="white-space: initial;"
          v-text="item.code"
        />
      </v-list-item-content>
    </template>
  </BAutocomplete>
</template>

<script>
import { openApiMixin } from './mixins'
import { PermissionsApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'


export default {
  name: 'BAutocompletePermission',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  created() {
    const api = new PermissionsApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(...args) {
      return this.adapter.getAll(...args)
    },
  },
}
</script>
